// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import { encryptTransform } from 'redux-persist-transform-encrypt';

// Import all slices
import AuthSlice from '../Slices/AuthSlice';
import TowFactorSlice from '../Slices/TowFactorSlice';
import PatientSlice from '../Slices/PatientSlice';
import AgeSlice from '../Slices/AgeSlice';
import FamilyMemberSlice from '../Slices/familyMemberSlice';
import TreatmentPlanSlice from '../Slices/TreatmentPlanSlice';

const encryptor = encryptTransform({
  secretKey: 'Pritam_Singh_Zimo_Infotech_74_dental_superAdmin',
});

const rootReducer = combineReducers({
  auth: AuthSlice,
  TowFactor: TowFactorSlice,
  PatientData: PatientSlice,
  AgeData: AgeSlice,
  FamilyMemberData: FamilyMemberSlice,
  TreatmentPlanData: TreatmentPlanSlice,
});

const persistConfig = {
  key: 'root',
  storage,
  transforms: [encryptor],
  blacklist: ['TreatmentPlanData'],
  whitelist: ['auth', 'TowFactor', 'PatientData', 'FamilyMemberData', 'AgeData'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const Store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default Store;
